<template>
  <SequenceDialog
    v-model:edit-item="contextSelected"
    v-model:episodes="episodes"
    v-model:show-dialog="showDialog"/>
  <DataTable
    v-model:context-menu-selection="contextSelected"
    v-model:editing-rows="editingRows"
    v-model:selection="selections"
    :loading="loading"
    :rowClass="rowClass"
    :value="items"
    class="p-datatable-sm"
    column-resize-mode="fit"
    data-key="id"
    edit-mode="cell"
    removable-sort
    reorderable-columns
    resizable-columns
    responsive-layout="scroll"
    scroll-height="flex"
    scrollable
    selection-mode="single"
    show-gridlines
    sort-mode="single"
    state-key="Sequences-grid"
    state-storage="local"
    striped-rows
    @row-contextmenu="rowContextMenu"
    @cell-edit-complete="update">
    <template #header>
      <div class="flex justify-content-between align-items-center">
        <h3 class="p-text-secondary">Sequences</h3>
      </div>
    </template>
    <template #footer>
      <Toolbar>
        <template #start>
          <Button
            class="mx-1"
            icon="pi pi-plus"
            label="Add sequence"
            @click="addRow()"/>
        </template>
        <template #end>
          In total there are {{ items?.length || 0 }} sequences.
        </template>
      </Toolbar>
    </template>
    <template #loading>
      Loading data. Please wait.
    </template>
    <template #empty>
      {{ error || "No Sequences" }}
    </template>
    <Column
      header="Episode"
      field="episode"
      :sortable="true"
      class="table-row-min"
      style="width: 20%">
      <template #editor="{ data, field }">
        <AutoComplete
          field="name"
          v-model="data[field]"
          class="input-text-autocomplete"
          :suggestions="suggestions"
          :dropdown="true"
          @complete="searchEpisode($event)"/>
      </template>
      <template #body="{data}">
        {{ data?.episode?.name }}
      </template>
    </Column>
    <Column
      header="Name"
      field="name"
      :sortable="true"
      class="table-row-min"
      style="width: 20%">
      <template #editor="{ data, field }">
        <InputText
          v-model="data[field]"
          autofocus
          class="input-text"/>
      </template>
    </Column>
    <Column
      :sortable="true"
      field="title"
      header="Title"
      style="width: 30%">
      <template #editor="{ data, field }">
        <InputText
          v-model="data[field]"
          autofocus
          class="input-text"/>
      </template>
    </Column>
    <Column
      header="Dropbox"
      field="url"
      style="width: 20%">
      <template #editor="{ data, field }">
        <InputText
          v-model="data[field]"
          autofocus
          class="input-text"/>
      </template>
      <template #body="{ data, field }">
        <span
          v-linkified
          v-html="data[field]"/>
      </template>
    </Column>
  </DataTable>
  <ContextMenu :model="menuModel" ref="cm"/>
</template>

<script type="module">
import SequencesService from "@/services/entity/SequencesService";
import EpisodesService from "@/services/entity/EpisodesService";
import GridService from "@/lib/GridService";
import SequenceDialog from "@/views/editors/grid/dialog/SequenceDialog";

export default {
  name: "SequencesGrid",
  components: {SequenceDialog},
  data() {
    return {
      changeState: {},
      showDialog: false,
      suggestions: null,
      episodes: [],
      error: null,
      items: [],
      editingRows: [],
      selections: [],
      contextSelected: null,
      loading: true,
      menuModel: [
        {
          label: "Edit",
          icon: "pi pi-fw pi-pencil",
          command: () => this.openEditor(this.contextSelected)
        },
        {
          label: "Delete",
          icon: "pi pi-fw pi-times",
          command: () => this.deleteConfirm(this.contextSelected)
        }
      ]
    }
  },

  created() {
    this.service = new SequencesService();
    this.episodeService = new EpisodesService();
    this.gridService = new GridService();
  },

  mounted() {
    this.get()
  },

  methods: {
    get() {
      this.service.list().then(data => {
        if (!data.error) {
          this.items = data
          this.loading = false
        } else {
          this.error = data.message
        }
      }).catch(e => {
        this.error = e
        this.loading = false
      })
      this.episodeService.list().then(data => {
        this.episodes = data
      })
    },
    addRow() {
      this.contextSelected = this.gridService.addRow(this.items)
      this.openEditor()
    },
    update(event) {
      this.gridService.updateRowEvent(
        event,
        this.service,
        this.changeState,
        true
      )
    },
    delete(item) {
      this.gridService.delete(
        this.items,
        item,
        this.service,
        this.changeState
      )
    },
    deleteConfirm(item) {
      this.$confirm.require({
        group: "confirm",
        header: "Delete Confirmation",
        message: "Do you want to delete this record?",
        icon: "pi pi-times",
        acceptClass: "p-button-danger",
        accept: () => this.delete(item)
      });
    },
    rowContextMenu(event) {
      this.gridService.rowContextMenu(
        event,
        this.$refs.cm,
        this.contextSelected,
      )
    },
    searchEpisode(event) {
      this.suggestions = this.episodes.filter(
        it => it.name.toLowerCase().includes(event.query.toLowerCase())
      )
    },
    rowClass(item) {
      return this.gridService.rowClass(
        item,
        this.changeState
      )
    },
    openEditor() {
      this.showDialog = true
    },
  }
}
</script>
